import Api from '@/services/Api'

export default {
    leaCompania(nit = null) {
        return Api().get('leaCompania', { params: { nit } })
    },
    leaCompaniaMunicipios(nit = null) {
        return Api().get('leaCompaniaMunicipios', { params: { nit } })
    },
    leaCompaniaCiius(nit = null) {
        return Api().get('leaCompaniaCiius', { params: { nit } })
    },
    leaCompaniaMunicipiosCiius(nit = null) {
        return Api().get('leaCompaniaMunicipiosCiius', { params: { nit } })
    },
    actualiceMunicipios(c_informacion) {
        return Api().put('actualiceMunicipios',c_informacion )
    },
    actualiceMunicipiosCiius(c_informacion) {
        return Api().put('actualiceMunicipiosCiius',c_informacion )
    },
}
